import script from "./ChatForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatForm.vue?vue&type=script&setup=true&lang=ts"

import "./ChatForm.vue?vue&type=style&index=0&id=9bea5334&lang=scss"

const __exports__ = script;

export default __exports__